<template>
  <div class="table-container">

    <table class="copyable-table">
      <thead>
        <tr>
          <th>机 构</th>
          <th  v-if="!isMobile">结构</th>
          <th  v-if="!isMobile">期限</th>
          <!-- 动态生成列标题 -->
          <th v-for="term in terms" :key="term">{{ term }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in tableData" :key="index">
          <td>{{ row.angry_name.replace('_雪球', '') }}</td>
          <td v-if="!isMobile">{{ row.structure }}</td>
          <td v-if="!isMobile">{{ row.term }}</td>
          <!-- 渲染各列数据 -->
          <td
            v-for="term in terms"
            :key="term"
            :class="{ 'red-text': isColumnMinValue(row[term], term) }"
          >
            {{ roundPercent(row[term]) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { copyTableToImage } from '@/utils/utils';

export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
    ,now_str: {
      type: String,
      default: () => ''
    }

  },
  data() {
    return {

       isMobile: window.innerWidth <= 768, // 判断是否为移动设备
    };
  },
  computed: {
      terms() {
      console.log('now_str:', this.now_str); // 验证值是否正确
      if (this.now_str === '折价建仓雪球') {
        return [
          '70-100-80',
          '70-103-80',
          '75-100-85',
          '75-103-85',
          '80-100-90',
          '80-103-90'
        ];
      } else {
        return [
          '70-100',
          '70-103',
          '75-100',
          '75-103',
          '80-100',
          '80-103',
          '85-100',
          '85-103'
        ];
      }
    },
     columnMaxValues() {
        const mins = {};
        this.terms.forEach(term => {
          const values = this.tableData
            .map(row => this.parseValue(row[term])) // 转换为数值
            .filter(v => !isNaN(v) && v !== 0); // 过滤无效值

          mins[term] = values.length > 0 ? Math.max(...values) : null;
        });
        return mins;
      }
  },
   watch: {
    now_str(newVal) {
      console.log('now_str changed to:', newVal);
      // 可选：强制更新最小值计算
      this.$nextTick(() => {
        console.log('New terms:', this.terms);
      });
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
   handleResize() {
      this.isMobile = window.innerWidth <= 768;
    },
   parseValue(val) {
      if (typeof val === 'string') {
        // 移除逗号（如 "1,000" → "1000"）
        val = val.replace(/,/g, '');
        // 处理百分比（如 "123%" → 123）
        if (val.includes('%')) {
          return parseFloat(val.replace('%', '')) || 0;
        }
        return parseFloat(val) || 0;
      }
      return parseFloat(val) || 0;
    },
    isColumnMinValue(value, term) {
      const parsedValue = this.parseValue(value);
      return parsedValue !== 0 && parsedValue === this.columnMaxValues[term];
    },
    roundPercent(value) {
      if (typeof value === 'string' && value.includes('%')) {
        const parsedValue = parseFloat(value.replace('%', '')) || 0;
        if (parsedValue < 1) {
          return (parsedValue * 100).toFixed(3) + '%';
        }
        return parsedValue.toFixed(2) + '%';
      }
      const numericValue = parseFloat(value) || 0;
      return (numericValue * 100).toFixed(2) + '%';
    },
    copyTableToImage() {
      const table = document.querySelector('.copyable-table');
      const firstRow = table.rows[1];
      const thirdCell = firstRow.cells[2];
      const cellContent = thirdCell.textContent;
      const fileName = '个股【'+cellContent+'】期权查询情况_' + this.currentDate + '.png';
      copyTableToImage(table, fileName);
    },
    copyTableYhToImage() {
      // 创建一个新的表格用于复制到图像
      const tempTable = document.createElement('table');
      tempTable.className = 'copyable-table';

      // 添加表头
      const thead = document.createElement('thead');
      const headerRow = document.createElement('tr');
      const headers = ['日期', '询价标的', '标的名称', '结构', '名义本金', '期限'];
      headers.forEach(header => {
        const th = document.createElement('th');
        th.textContent = header;
        headerRow.appendChild(th);
      });
      thead.appendChild(headerRow);
      tempTable.appendChild(thead);

      // 添加表体
      const tbody = document.createElement('tbody');
      this.tableData.forEach(row => {
        const tr = document.createElement('tr');
        const cells = [row.date, row.stock_code, row.stock_name, row.structure, row.total_principal_label, row.term];
        cells.forEach(cell => {
          const td = document.createElement('td');
          td.textContent = cell;
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      });
      tempTable.appendChild(tbody);

      const firstRow = tempTable.rows[1];
      const thirdCell = firstRow.cells[2];
      const cellContent = thirdCell.textContent;
      console.log(tempTable);
      const fileName = '个股【'+cellContent+'】期权查询情况_' + this.currentDate + '.png';
      copyTableToImage(tempTable, fileName);
    },
    yh_price() {
          const table = document.querySelector('.copyable-table');
          const firstRow = table.rows[1];
          const thirdCell = firstRow.cells[1];
          const fourCell = firstRow.cells[2];

          const stock_code = thirdCell.textContent;
          const stock_name = fourCell.textContent;

          let text = " 标的：" + stock_name + " " + stock_code + "\n";
          text += " 期权结构：100%\n";
          text += " 名义本金：100W\n";
          text += " 期权费率：100%\n";
          text += " 时间期限：1M";

          // 使用 Clipboard API 将内容复制到剪贴板
          navigator.clipboard.writeText(text)
            .then(() => {
              console.log('内容已成功复制到剪贴板');
              alert('内容已成功复制到剪贴板');
            })
            .catch(err => {
              console.error('无法复制内容到剪贴板', err);
              alert('无法复制内容到剪贴板');
            });
    }
  }
};
</script>

<style scoped>
/* 页面容器 */
.table-container {
  padding: 1rem;
  max-width: 100%;
  box-sizing: border-box;

}

/* 表格容器 */
.table-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 50px; /* 新增表格底部间距 */
}

.copyable-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
  line-height: 1.5;
}

.copyable-table th,
.copyable-table td {
  padding: 0.5rem;
  text-align: center;
  border: 1px solid #ddd;
}

.copyable-table th {
  background-color: #f8f9fa;
  min-width: 5rem;
}

.red-text {
  color: #ff0000; /* 最小值标红 */
  font-weight: bold;
}

.highlight {
  background-color: #ffeb3b;
}

/* 按钮样式 */
.button {
  font-size: 0.9rem;
  padding: 0.5rem;
  margin: 0.5rem 0;
  border-radius: 0.25rem;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
}

.button:hover {
  background-color: #0056b3;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .table-container {
    padding: 0.5rem;
    width: 100%;
    overflow-x: auto;
  }

  .copyable-table {
    font-size: 0.8rem;
  }

  .button {
    font-size: 0.8rem;
    padding: 0.5rem;
    width: 100%;
  }
}
</style>
